import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'
import App from './containers/app'
/* import { CookiesProvider } from 'react-cookie'; */
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/app.css';
import './assets/css/popup.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/css/app-responsive.css';

import './index.css';
const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </Provider>,
  target
)
